import { getPercentageChange, zeroIfNaN } from "../../../utils/numbers";
import {
  getOneMonthAgo,
  getMonthTotal,
  getMonthAverage,
  getMonthValue,
} from "./dataUtils";

/**
 * HACK!!
 * NOTE: These magic numbers have been calculated by hand via Jira
 * These will need to be periodically updated, by hand, as the averages change over time
 * This is an understood compromise for the short-term.
 * DO NOT FOLLOW THIS EXAMPLE!!!
 */
const MAGIC_BUENO_ACTIVE_AVERAGE_NUMBER = 90;
const MAGIC_BUENO_CLOSED_AVERAGE_NUMBER = 60;

export function getMonthlyValueDelta(data, timestamp, key = "total") {
  if (!data) {
    return {
      value: 0,
      delta: 0,
    };
  }

  const lastMonth = getOneMonthAgo(timestamp);

  const total = getMonthTotal(data, timestamp, key);
  const lastMonthTotal = getMonthTotal(data, lastMonth, key);
  const delta = Number(total) - Number(lastMonthTotal);
  return {
    value: total,
    delta,
  };
}

export function getDaysAvgDelta(data, timestamp, magicNumber, key = "age") {
  const value = Math.round(getMonthAverage(data, timestamp, key));
  const prevMonthValue = Math.round(
    getMonthAverage(data, getOneMonthAgo(timestamp), "age")
  );
  const delta = value - prevMonthValue;
  const buenoAverageDelta = getPercentageChange(magicNumber, value, 0);

  return {
    days: value,
    delta,
    average: buenoAverageDelta, // NOTE: this field is not yet used.  Delete it?
  };
}

export function composeReportData(data, timestamp) {
  const lastMonth = getOneMonthAgo(timestamp);
  const outstandingValue = zeroIfNaN(
    Number(getMonthValue(data.outstanding, timestamp, "total"))
  );
  const outstandingDelta =
    outstandingValue -
    zeroIfNaN(Number(getMonthValue(data.outstanding, lastMonth, "total")));

  const openIssueCount = zeroIfNaN(
    Number(getMonthValue(data.open, timestamp, "total"))
  );
  const openIssueDelta =
    openIssueCount -
    zeroIfNaN(Number(getMonthValue(data.open, lastMonth, "total")));

  const atAGlance = {
    done: {
      closed: getMonthlyValueDelta(data.closed, timestamp),
      raised: getMonthlyValueDelta(data.raised, timestamp),
    },
    next: {
      open: {
        value: openIssueCount,
        delta: openIssueDelta,
      },
      pending: {
        value: zeroIfNaN(Number(data.pending)),
        delta: 0,
      },
      stagnant: {
        value: zeroIfNaN(Number(data.stagnant)),
        delta: 0,
      },
    },
    progress: {
      outstanding: {
        value: outstandingValue,
        delta: outstandingDelta,
      },
      active: getDaysAvgDelta(
        data.activeAge.delta,
        timestamp,
        MAGIC_BUENO_ACTIVE_AVERAGE_NUMBER
      ),
      industryAvgActive: MAGIC_BUENO_ACTIVE_AVERAGE_NUMBER,
      closed: getDaysAvgDelta(
        data.closeAge.delta,
        timestamp,
        MAGIC_BUENO_CLOSED_AVERAGE_NUMBER
      ),
      industryAvgClosed: MAGIC_BUENO_CLOSED_AVERAGE_NUMBER,
    },
  };

  return {
    atAGlance,
  };
}
